(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("chem-elements", [], factory);
	else if(typeof exports === 'object')
		exports["chem-elements"] = factory();
	else
		root["chem-elements"] = factory();
})(typeof self !== 'undefined' ? self : this, function() {
return 